import { Category } from './enums';
import { VendorApp } from './vendors';

export const randomCategoryImagesByVendor: Record<VendorApp, string[]> = {
  [VendorApp.Modalyst]: [
    'https://media.modalyst.co/cache/8f/fb/8ffb58fa03c1b8a52b3d0f0ce3b82ba4.jpg',
    'https://media.modalyst.co/cache/91/db/91db9e9e36258e5fa2fa3ee610293fb3.jpg',
    'https://media.modalyst.co/cache/9a/2f/9a2f42db29a70c7b736e677fde690b7f.jpg',
  ],
  [VendorApp.AutoDs]: [
    'https://autods-scraper-images.s3-us-west-2.amazonaws.com/6b1e2ea6545bc66676ba8b74c3f18204.png',
    'https://autods-scraper-images.s3-us-west-2.amazonaws.com/1da599b640cd23254da16d021f6c89cd.png',
    'https://autods-scraper-images.s3-us-west-2.amazonaws.com/095af64cf4081759d5e1c521b26d9003.png',
  ],
  [VendorApp.ZenDrop]: [
    'https://file.zendrop.com/products/37/22/01e3eb83406ea57842b0c35e16d4.png',
    'https://file.zendrop.com/products/62/4f/498d3a974902865eb58c3eac8ee0.png',
    'https://file.zendrop.com/products/06/3e/97a16f4d41758c0dbaf5107d149b.jpeg',
  ],
};

export const categoryImagesByVendor: Record<VendorApp, Partial<Record<Category, string[]>>> = {
  [VendorApp.Modalyst]: {
    [Category.BeautyHealth]: [
      'https://media.modalyst.co/cache/22/71/22714f6fbde831c38be4df8fc108bc53.jpg',
      'https://media.modalyst.co/cache/75/5a/755ac8daf3f7c261fdd549fe9b282039.jpg',
      'https://media.modalyst.co/cache/c3/14/c314843234dae3c8c11baa044c2eea86.png',
      'https://media.modalyst.co/cache/44/e3/44e397a90383cbde9e4a2b921d085e18.jpg',
      'https://media.modalyst.co/cache/a1/f7/a1f74232576c950f04165ef8ef7cff14.jpg',
      'https://media.modalyst.co/cache/7e/a7/7ea737f372a54f8fa91509e1f14b9c54.jpg',
    ],
    [Category.MensFashion]: [
      'https://media.modalyst.co/cache/d5/83/d583a692876e12efa964fb951d446f30.jpg',
      'https://media.modalyst.co/cache/53/45/534592c59fe11ec07698865f27f5abf4.png',
      'https://media.modalyst.co/cache/ec/1e/ec1ec3a2403fdd3ffe27ad9149fbb02a.jpg',
      'https://media.modalyst.co/cache/1c/7f/1c7ffad5c2d10a28880a1b1fad0e618d.png',
      'https://media.modalyst.co/cache/fe/e8/fee8681753894fcad31b5e255e690c51.jpg',
      'https://media.modalyst.co/cache/44/62/4462e475e8e6507bd7d6a283d317cef5.png',
    ],
    [Category.JewelryAccessories]: [
      'https://media.modalyst.co/cache/91/db/91db9e9e36258e5fa2fa3ee610293fb3.jpg',
      'https://media.modalyst.co/cache/e3/7c/e37ca83b175bb403410346b14a375741.jpg',
      'https://media.modalyst.co/cache/d6/41/d641f81c91e1221ec79afcf8ac685047.jpg',
      'https://media.modalyst.co/cache/0d/24/0d246cabc81f804ea545158889d9a9c8.jpg',
      'https://media.modalyst.co/cache/d4/46/d4469c82c00462ff092078a1b0450ed7.jpg',
      'https://media.modalyst.co/cache/17/3d/173dd3d88a369cbb9d653c54218cd42c.jpg',
    ],
    [Category.ConsumerElectronics]: [
      'https://media.modalyst.co/cache/d4/f5/d4f57b382de4b1cef32c5b030a498753.jpg',
      'https://media.modalyst.co/cache/10/5a/105ad37d58c1c34f5ea76f968557233e.jpg',
      'https://media.modalyst.co/cache/4b/ab/4babc0a9d32adadc5ab3db4a064350d4.jpg',
      'https://media.modalyst.co/cache/ec/38/ec3859edeb509c88270ac3b693aeab2f.png',
      'https://media.modalyst.co/cache/f3/69/f369a22517c451447de915c10587ffc0.png',
      'https://media.modalyst.co/cache/69/86/69866129829db1b5cd0f6a1325d74ef8.png',
    ],
    [Category.HomeGarden]: [
      'https://media.modalyst.co/cache/7d/fd/7dfd88f4b8c919dfca6c68faaabd886d.png',
      'https://media.modalyst.co/cache/ce/48/ce48263bcff9a2c3cad47c45eb79bfbb.jpg',
      'https://media.modalyst.co/cache/9d/c2/9dc22ebe47f71dfd4adfa778701f4d1a.jpg',
      'https://media.modalyst.co/cache/82/a7/82a7b6c1d47141739e547778c30d10c8.jpg',
      'https://media.modalyst.co/cache/d2/cf/d2cf55931176df5b674b8c2476a71623.png',
      'https://media.modalyst.co/cache/f5/03/f5039e3234e3374157185d52fedae2eb.png',
    ],
    [Category.KidsBabies]: [
      'https://media.modalyst.co/cache/2e/4d/2e4d0863aae3001edd52d1fdc9c43eb1.png',
      'https://media.modalyst.co/cache/11/94/119465f3def0feb349bfdd7678c425af.jpg',
      'https://media.modalyst.co/cache/9e/26/9e26115d2e8e4b0bd65dd3286fe033e5.jpg',
      'https://media.modalyst.co/cache/4a/d2/4ad22daecc2fe15954b8860a4395b7ad.jpg',
      'https://media.modalyst.co/cache/83/35/8335734c543d354f8abc0f6505ef20df.jpg',
      'https://media.modalyst.co/cache/eb/13/eb134a9b3b19022fb7d7181f3400a7a9.jpg',
    ],
    [Category.SportsEntertainment]: [
      'https://media.modalyst.co/cache/d3/2a/d32aae40a1d8b8f0c8093e1c7562a69f.jpg',
      'https://media.modalyst.co/cache/a8/7b/a87bfed0f59e88445662537ec8e4e8f2.jpg',
      'https://media.modalyst.co/cache/ed/a2/eda21302480e3508acbd28a9ae38c319.jpg',
      'https://media.modalyst.co/cache/de/07/de075e54135e9f9da3679f25a392ffe3.png',
      'https://media.modalyst.co/cache/9c/e5/9ce5034c3ff6ae9c2b14fc1c209e7661.png',
      'https://media.modalyst.co/cache/1b/84/1b841d142a9c138ebd0a7560a72d6f2a.png',
    ],
    [Category.WomensFashion]: [
      'https://media.modalyst.co/cache/8f/fb/8ffb58fa03c1b8a52b3d0f0ce3b82ba4.jpg',
      'https://media.modalyst.co/cache/fd/fe/fdfe2f7fb9deb23ce986141eefec5e90.jpg',
      'https://media.modalyst.co/cache/30/82/308289c2f7a0e41a18400ae3a64d8325.jpg',
      'https://media.modalyst.co/cache/8b/e1/8be118f5cb1dbd90d8e6e8c400ddd111.jpg',
      'https://media.modalyst.co/cache/7d/74/7d74aca6c08b7c95469009825a61d967.png',
      'https://media.modalyst.co/cache/dd/49/dd49bec2325063ef17479a82163733fb.jpg',
    ],
    [Category.BagsLuggage]: [
      'https://media.modalyst.co/cache/9a/2f/9a2f42db29a70c7b736e677fde690b7f.jpg',
      'https://media.modalyst.co/cache/50/15/5015c8c0e6f2f28de3091cc28f8a25ea.jpg',
      'https://media.modalyst.co/cache/c5/61/c5611df91f51624ed53abead15edf681.jpg',
      'https://media.modalyst.co/cache/97/11/971154bcad85803be2016882a03d099f.jpg',
      'https://media.modalyst.co/cache/63/a5/63a599de2f944d38704e71258eb397c7.jpg',
      'https://media.modalyst.co/cache/15/86/1586fd0a63ed0740779716b693bb2a5d.jpg',
    ],
    [Category.Pets]: [
      'https://media.modalyst.co/cache/4a/0a/4a0a84ca4f29ac0cdb9109360f70abdf.jpg',
      'https://media.modalyst.co/cache/91/31/913189cd8a51f174a4de8e9611fedfde.jpg',
      'https://media.modalyst.co/cache/b4/70/b470f35f9a2561040618852f5a78a228.jpg',
      'https://media.modalyst.co/cache/d8/ed/d8ed26d30b518869f33127d0d7bfb874.jpg',
      'https://media.modalyst.co/cache/fb/a2/fba23eb479ea2f471399d7828c0a5b75.jpg',
    ],
  },
  [VendorApp.AutoDs]: {
    [Category.WomensFashion]: [
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/6b1e2ea6545bc66676ba8b74c3f18204.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/e15c1836a2588c42c9b7a0f9b1f5ef41.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/41a579b989514fd4971f94652f855fb3.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/5f4b814312e65b19219a4f1325fc0b09.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/9cf61d30df99ef81df6d653d15c9b202.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/595c5179c23c75c61302226fb6ea6650.png',
    ],
    [Category.ConsumerElectronics]: [
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/1da599b640cd23254da16d021f6c89cd.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/4f2e4d836f495cc3c0caaf0e13aee832.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/41191b5120463093ca6037a7ff0f26ae.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/3a56da03ef10ea57d62499292ddf87f9.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/daf73a25597a0bc0500e19d552b33af8.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/e9a1d5d956a23074830e990179afe095.png',
    ],
    [Category.HomeGarden]: [
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/095af64cf4081759d5e1c521b26d9003.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/2856d7db4bdaa6b3f63a08e73d18435e.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/097a8c5618cecbc511d2fe6e9c489c63.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/2c2a7cd210a66865dfffe4f7e3c73cab.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/1244cd0a0cafc85dcb294946351357d6.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/6d8e1e1cfe25071c9c6300815dcc7749.png',
    ],
    [Category.Pets]: [
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/05cb20b0c526ad2fb88629321df00d81.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/eba36af28ea679e8dc4961804d37b667.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/893ed9fa37d24b6fd9eeb27e9cc6e316.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/915eb4776b456f05bb4865fa2c1e9819.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/cf6a26015ce3fc6e161a90eff1970930.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/fefd9394520ac878c8dea4bd21866aca.png',
    ],
    [Category.SportsEntertainment]: [
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/79b099ca445a8b37ca84bcac7d20cd9c.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/1a269e90490c9411e678d5547d826a6f.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/9cc34e9b4cd3986f2fcacaab860905e1.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/0ba7e4bb901a19689c7ce4efd44cb7c4.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/cece7fc3551c09708eeacfe5e16d9a87.png',
      'https://autods-scraper-images.s3-us-west-2.amazonaws.com/4bd1b65bdcc727597fc60a9bc9ce7e03.png',
    ],
  },
  [VendorApp.ZenDrop]: {
    [Category.WomensFashion]: [
      'https://file.zendrop.com/products/37/22/01e3eb83406ea57842b0c35e16d4.png',
      'https://file.zendrop.com/products/c5/44/36ef5c06461fa482c00d60e086b6.png',
      'https://file.zendrop.com/products/04/29/cc4d65c74bcdb4f4e936ec8df977.png',
      'https://file.zendrop.com/products/0a/2d/5d208fe04e919bbcdaefb45bfc31.png',
      'https://file.zendrop.com/products/58/7f/90f588ec43d69b2c667dcd7db3e4.png',
      'https://file.zendrop.com/products/8d/f3/372332b444c488d3c026cb5bc0e7.png',
    ],
    [Category.MensFashion]: [
      'https://file.zendrop.com/products/19/c8/e3d1008f41baaa4d4a17dcafcdd1.png',
      'https://file.zendrop.com/products/fb/95/49da14b748ae9fa8d162f6c7c5df.jpeg',
      'https://file.zendrop.com/products/2d/97/477e2e30425498f5504b7ff5ef64.png',
      'https://file.zendrop.com/products/14/df/566ce4e44ef591ea7b376e9f8a23.png',
      'https://file.zendrop.com/products/d5/d4/f1a4e0e840c9aeec026baa55a94a.png',
      'https://file.zendrop.com/products/ac/a5/eca20a14480bacde04dc2ea9bfbd.png',
    ],
    [Category.JewelryAccessories]: [
      'https://file.zendrop.com/products/62/4f/498d3a974902865eb58c3eac8ee0.png',
      'https://file.zendrop.com/products/6a/35/b97bf9ef4b76aebffb573ad1c638.png',
      'https://file.zendrop.com/products/ef/87/752fbcfa497a8a526b842c30391e.png',
      'https://file.zendrop.com/products/f7/b0/b61fff6e42a6b471159587c31e0d.png',
      'https://file.zendrop.com/products/ee/6d/95ecd6b54032b296c616b1e9278e_import.webp',
      'https://file.zendrop.com/products/85/9e/d5dd98424fa583090a92c08cc178_import.webp',
    ],
    [Category.KidsBabies]: [
      'https://file.zendrop.com/products/20/a6/019b90554170bf26d211c287b36e.png',
      'https://file.zendrop.com/products/5f/84/6e34e9594298b3eb6cf8fef3e949.png',
      'https://file.zendrop.com/products/3b/f7/8c5e66564b3dbeacbf7fa8e53a58.png',
      'https://file.zendrop.com/products/b8/b3/7cf6f88d4700996c4a805660b88a.png',
      'https://file.zendrop.com/products/07/f9/0187ebcf4bc3bc5602f62fbdb02f_import.webp',
      'https://file.zendrop.com/products/48/b0/a047c8824ce0a734cbd1f894b3a1_import.webp',
    ],
    [Category.BeautyHealth]: [
      'https://file.zendrop.com/products/8d/2c/22287a3e41d2b0201e23bcc3572b.png',
      'https://file.zendrop.com/products/05/10/014628474f5eb08d33d5268c4620.png',
      'https://file.zendrop.com/products/6b/76/532c2128409f814c51ec82f98f1d.jpeg',
      'https://file.zendrop.com/products/f4/bc/179728f74541b5dcd699476c01ec.png',
      'https://file.zendrop.com/products/27/dc/34be174b4f7ebec54d98127a845c.png',
      'https://file.zendrop.com/products/cb/92/89e073f94ddd92ea45f55a0228b1_import.webp',
    ],
    [Category.HomeGarden]: [
      'https://file.zendrop.com/products/3a/ed/63561d5e48c88024fdbda296888b.png',
      'https://file.zendrop.com/products/7a/54/2850726d4c6ea7839a461cbf5f48.png',
      'https://file.zendrop.com/products/69/57/4642e31441c8957357a762393bcd.jpeg',
      'https://file.zendrop.com/products/b1/21/833e7d86478e801a12fe40359271.png',
      'https://file.zendrop.com/products/a6/0f/dbe7cbb24aa79f80584f84c6d01c_import.webp',
      'https://file.zendrop.com/products/ea/b8/c09af5b244cbb66ab65f55e03e8b_import.webp',
    ],
    [Category.SportsEntertainment]: [
      'https://file.zendrop.com/products/1f/fd/76bcc2354152a301b9ce75271bef.png',
      'https://file.zendrop.com/products/86/8b/52560dfc40c9a9217ce7cd2c61c2.png',
      'https://file.zendrop.com/products/92/f1/cd3391114257998990ad3c368ae7.jpeg',
      'https://file.zendrop.com/products/49/d0/e2789a17432fa2711665e38c18da.jpeg',
      'https://file.zendrop.com/products/ce/95/35633380467d85eb1b75e5d642a9.png',
      'https://file.zendrop.com/products/11/96/8b711dc04d9ca0a5983ee2e6348b.png',
    ],
    [Category.BagsLuggage]: [
      'https://file.zendrop.com/products/06/3e/97a16f4d41758c0dbaf5107d149b.jpeg',
      'https://file.zendrop.com/products/c2/67/c6171a7a459ba0117f784f9020a9.png',
      'https://file.zendrop.com/products/ba/ba/449be81b4925ae46559f52543a52.jpeg',
      'https://file.zendrop.com/products/72/74/b744061e4965a1ecb0a2234edd1b.jpeg',
      'https://file.zendrop.com/products/5a/20/27b9124a4bc292b8ac1b51b5b6da.png',
      'https://file.zendrop.com/products/cd/cc/92daf01d4abfa0137a87133d6aab.png',
    ],
    [Category.ConsumerElectronics]: [
      'https://file.zendrop.com/products/5e/bd/c50dc5d746a2916426f33489b2ce.png',
      'https://file.zendrop.com/products/c1/a9/83db826d47f8a1f6a07ad14b654d.png',
      'https://file.zendrop.com/products/d5/27/986438fd429cb184ffe6ac81949a.png',
      'https://file.zendrop.com/products/04/65/044127af4324b75ccd579b91244b.png',
      'https://file.zendrop.com/products/38/42/8f7dfc484663b5252166f3bcb9be.webp',
      'https://file.zendrop.com/products/9c/58/fe3fa9434f85977a6f2711c5b20a.png',
    ],
    [Category.Pets]: [
      'https://file.zendrop.com/products/15/32/641be8844412afac6df132cb8ffd.jpeg',
      'https://file.zendrop.com/products/38/b9/cf3374c94a909c30720e7b28da30.png',
      'https://file.zendrop.com/products/ce/0c/91b7d46442cbb74b3de44cb61222.png',
      'https://file.zendrop.com/products/4d/61/2ca5fd2b4601822c1f1f1c9b01e6.jpeg',
      'https://file.zendrop.com/products/f2/a9/d3890b2e48418efea49c91fe8a3d.jpeg',
      'https://file.zendrop.com/products/b3/5a/b916045e4f0489afe983342a56cc.png',
    ],
  },
};
